<template>
  <div class="tabBox">
    <van-row class="fvlr">
      <van-col v-for="(item, index) in data" :span="24 / data.length" :key="index" @click.stop="clickTab(item, index)">
        <div class="tabItemBox">
          <div :class="['tab', active == item.id ? 'active ' : '']" :style="active == item.id ? activeStyle : style">
            <slot name="content">
              <van-badge v-if="item.num > 0" :content="item.num" color="#f49b55" max="10"
                ><span>{{ item.text }}</span>
              </van-badge>
              <span v-else>{{ item.text }}</span>
            </slot>
          </div>
        </div>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import { reactive, toRefs } from 'vue'
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    active: {
      type: [Number, String],
      default: 0
    },
    activeStyle: {
      type: String,
      default: ''
    },
    style: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit }) {
    let { data, active, activeStyle, style } = toRefs(props)
    const state = reactive({
      data: data.value,
      active: active.value,
      activeStyle: activeStyle.value,
      style: style.value
    })
    let clickTab = v => {
      emit('click', v)
    }
    return {
      ...toRefs(state),
      clickTab
    }
  }
}
</script>
<style lang="scss" scoped>
.tab {
  color: #333;
  font-size: 14px;
  span {
    padding: 5px;
    border-bottom: 3px solid transparent;
  }
}
.active {
  // font-weight: 700;
  font-size: 16px;
  color: #3088c5;
  span {
    border-bottom: 3px solid#3088c5;
  }
}
.tabItemBox {
  padding: 10px 0 6px;
}
</style>
